import { ACTION_TASK_CONSTANTS } from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";
import { DEPENDENCIES_ACCESS } from "@/modules/Dependencies/constants/DependenciesConstants";
import { DependenciesService } from "@/modules/Dependencies/services/DependenciesService";
import { DependencyQuery } from "@/modules/User/models/DependencyQuery";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { GENERAL_CONSTANTS, STATE } from "@/shared/constants/GeneralConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "AsingTaskDependency",
  components: { DynamicSelect }
})
export default class AsingTaskDependency extends Vue {
  @Inject() dependenciesService!: DependenciesService;

  @Prop() dependency!: string;

  listDependencyConfig: DynamicSelectConfig = {
    listAll: [],
    default: [],
    messageLabel: ACTION_TASK_CONSTANTS.LABELS.DEPENDENCY_LABEL,
    required: true,
    attach: false
  };
  listDependencyModel = [{ id: "", name: "" }];
  dependencyLastReference = "";

  async mounted() {
    await this.loadDependencies();
  }

  @Watch("listDependencyModel")
  updateState() {
    this.$emit(
      ACTION_TASK_CONSTANTS.EMMITS.UPDATE_DEPENDENCY,
      this.listDependencyModel[0].id
    );
  }

  async handleDependency(depName: string) {
    const responseName = await this.dependenciesService.getDependenciesWithFilters(
      { name: depName.toUpperCase(), state: [STATE.ACTIVE] }
    );
    if (responseName.code == Http.Found && responseName.data) {
      this.listDependencyConfig.listAll = [
        ...this.listDependencyConfig.listAll,
        ...(responseName.data.data as DynamicSelectData[])
      ];
    }
  }

  async loadDependencies(depName?: string) {
    this.listDependencyConfig.notFound = false;
    try {
      if (depName) {
        await this.handleDependency(depName);
        return;
      }

      const filters: DependencyQuery = {
        state: [STATE.ACTIVE],
        paginatedResult: true,
        docref: this.dependencyLastReference
      };

      if (this.dependencyLastReference !== "") {
        filters.docref = this.dependencyLastReference;
      } else {
        delete filters.docref;
      }

      const response = await this.dependenciesService.getDependenciesWithFilters(
        filters
      );
      this.dependencyLastReference = response.data?.docRef ?? "";

      if (response.code === Http.Found && response.data) {
        if (this.dependencyLastReference !== "") {
          this.listDependencyConfig.listAll = [
            ...this.listDependencyConfig.listAll,
            ...(response.data.data as DynamicSelectData[])
          ];
        } else {
          this.listDependencyConfig.listAll = [
            ...(response.data.data as DynamicSelectData[])
          ];
        }
      } else {
        this.listDependencyConfig.notFound = true;
        this.dependencyLastReference = "";
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      this.listDependencyConfig.notFound = true;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DEPENDENCIES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return;
    }
  }
}
